export const roundToTwoDecimals = (num) =>
  Math.round((num + Number.EPSILON) * 100) / 100

export const numberOnly = (e) => {
  if (
    [8, 9, 13, 27, 46, 37, 38, 39, 40].includes(e.keyCode) ||
    (e.ctrlKey && [65, 67, 86, 88].includes(e.keyCode))
  ) {
    return
  }
  if (
    !/[0-9]/.test(e.key) &&
    !(e.key === '.' && !e.target.value.includes('.'))
  ) {
    e.preventDefault()
  }
}
